export default class ShopDOMHelper {
  static querySelectorAll(selector) : HTMLElement[] {
    return Array.from(document.querySelectorAll(selector));
  }
  static querySelector(selector) : HTMLElement {
    return document.querySelector(selector);
  }
}
